import { FormStateInitialValues } from '@policygenius/mortar-dynamic-forms';

import { createVirtualMultiChoiceDPID } from 'containers/utils';

import { HAZARDOUS_ACTIVITIES_URNS } from '../constants';
import { FormValues } from '../types';

const buildInitialValues = (
  data: Record<string, any> | undefined
): FormStateInitialValues<FormValues> => ({
  'urn:pg:data-point:insured-risk-activity-description':
    data?.['urn:pg:data-point:insured-risk-activity-description'],
  'urn:pg:data-point:virtual-insured-hazardous-activities-list': createVirtualMultiChoiceDPID(
    data,
    HAZARDOUS_ACTIVITIES_URNS
  ),
});

export default buildInitialValues;
